import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

// Create a custom styled Tooltip
const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
))(({ theme }) => ({
    backgroundColor: "#000",
    "& .MuiTooltip-arrow": {
        color: "#000", // Tooltip arrow color
        transition: "none"
    },
}));

export default CustomTooltip;
